import React, { useState, useEffect } from "react";
import NoFooterModal from "../../Common/NoFooterModal";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as TelecallerLeadsActions from "../../../store/actions/TelecallerLeads";
import { getInitialState } from "../../../utils";
import * as UserActions from "./../../../store/actions/User";
import { removeEmptyVals } from "../../../utils";

import {
  BottomSectionModal,
  FlexContainer,
} from "../../../constants/assets/containers";

const TeleLeadsFilterFormModal = (props) => {
  const [followupDateState, setFollowupDateState] = useState(true);
  const [clearButtonState, setClearButtonState] = useState(true);
  const [formError, setFormError] = useState(false);
  const [initialState, setInitialState] = useState({
    filter_type: "",
    filter_value: "",
    followup_date: "",
  });

  const handleChange = (key, val) => {
    const values = { ...initialState };
    if (key === "filter_type") {
      values["filter_value"] = "";
      values["followup_date"] = "";
    }
    if (key === "filter_value") {
      values["followup_date"] = "";
    }
    values[key] = val;
    if (
      values["filter_type"] === "call_status" &&
      values["filter_value"] === "ENGAGEMENT_INPROCESS"
    ) {
      setFollowupDateState(false);
    } else {
      setFollowupDateState(true);
    }
    setInitialState(values);
    setFormError(false);
  };

  const handleSubmit = () => {
    const payload = removeEmptyVals(initialState);
    let error = formError;
    if (payload["filter_type"] != "" && payload["filter_value"] === "") {
      props.setStatus({
        type: "error",
        message: "Please select Filter Value",
      });
      error = true;
    }
    if (
      payload["filter_type"] === "call_status" &&
      payload["filter_value"] === "ENGAGEMENT_INPROCESS" &&
      payload["followup_date"] === ""
    ) {
      props.setStatus({
        type: "error",
        message: "Please select Followup Date",
      });
      error = true;
    }
    if (!error) {
      const pageRequest = {
        page_number: 1,
      };
      props.filterLeadEngagement(payload, pageRequest, props.activeTelecaller);
      props.handleClose();
    }
  };

  const handleFilterClear = () => {
    if (Object.keys(props.activeFilter).length > 0) {
      props
        .getTelecallerLeads(props.activeTelecaller, { page_number: 1 })
        .then((res) => {
          props.resetState({ state: "activeFilter" });
          props.handleClose();
        });
    }
  };
  const filterTypes = ["source_channel", "shift_type", "call_status"];
  const filters = {
    "": [],
    source_channel: [
      "Driver Referral",
      "Runnr Buddy Referral",
      "DIY",
      "Driver Runnr Request",
    ],
    shift_type: ["FULL_TIME", "PART_TIME", "WEEKEND"],
    call_status: ["ENGAGEMENT_COMPLETED", "OPEN", "ENGAGEMENT_INPROCESS"],
  };

  useEffect(() => {
    // update the initialState on modal render.
    if (Object.keys(props.activeFilter).length > 0) {
      const values = { ...initialState };
      Object.keys(values).map((key) => {
        values[key] = props.activeFilter[key]
          ? props.activeFilter[key]
          : getInitialState(initialState, key);
      });
      if (
        values["filter_type"] === "call_status" &&
        values["filter_value"] === "ENGAGEMENT_INPROCESS"
      ) {
        setFollowupDateState(false);
      } else {
        setFollowupDateState(true);
      }
      setInitialState(values);
    }
  }, [props.activeFilter]);
  return (
    <NoFooterModal
      header
      heading="Telecaller Leads Filter"
      handleClose={props.handleClose}
      id="telecallerLeadsFilter"
      modalButtons={
        <BottomSectionModal>
          <FlexContainer>
            <Button
              onClick={handleSubmit}
              className="sushi-btn"
              disabled={!initialState.filter_value}
            >
              Apply
            </Button>
            <Button
              onClick={handleFilterClear}
              className="sushi-btn"
              disabled={!Object.keys(props.activeFilter).length > 0}
            >
              Clear
            </Button>
          </FlexContainer>
        </BottomSectionModal>
      }
    >
      <PaginatedReactDropdown
        options={filterTypes}
        labelWidth="20%"
        handleChange={handleChange}
        keyToChange="filter_type"
        placeholder="Filter Type"
        showCross={true}
        showPagination={false}
        value={initialState.filter_type}
        id="teleleadsFilterTypesDropdown"
      />
      <PaginatedReactDropdown
        options={filters[initialState.filter_type]}
        labelWidth="20%"
        handleChange={handleChange}
        keyToChange="filter_value"
        placeholder="Filter Value"
        showCross={true}
        disabled={!initialState.filter_type}
        showPagination={false}
        value={initialState.filter_value}
        id="teleleadsFilterValueDropdown"
      />
      <Input
        id="sushi-input"
        fullWidth={true}
        value={initialState.followup_date}
        label="Follow Up Date"
        type="date"
        onChange={(e) => handleChange("followup_date", e)}
        disabled={followupDateState}
      />
    </NoFooterModal>
  );
};

const mapStateToProps = (state) => {
  const { TelecallerLeads } = state;
  return {
    currentPage: TelecallerLeads.currentPage,
    activeFilter: TelecallerLeads.activeFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    filterLeadEngagement: bindActionCreators(
      TelecallerLeadsActions.filterLeadEngagement,
      dispatch
    ),
    resetState: bindActionCreators(TelecallerLeadsActions.resetState, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getTelecallerLeads: bindActionCreators(
      TelecallerLeadsActions.getTelecallerLeads,
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeleLeadsFilterFormModal);
